<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
</style>

<template>
  <v-row justify="center" align="center">
    <v-col xs="12" sm="10" md="8" lg="8" xl="7">
        <v-form ref="form" @submit.prevent="submitForm($event)">
          <v-card class="br-10 text-center elevation-3">
            <span class="title primary--text text--darken-2" style="word-break: break-word;"><strong>MDKGU {{ $t("assessment") }}<br> {{ $t('ebilling_registration_form') }}</strong></span>
            <br>
            <span class="font-weight-bold text-left"><span class="error--text">*</span> {{ $t("requiredField") }}</span>
            <br>
            <v-row class="text-left">
              <v-col cols="12">
                1. <span>{{ $t('ebill_registered_name') }}<br>({{ $t('as_stated_in_assessment_bill') }}) <br><span class="error--text">*</span></span>
                <v-text-field outlined name="ebill_registered_name" v-model="data.customer.name" :placeholder="$t('enter_your_answer')" required type="text" :rules="[rules.required]" :disabled="loading" :readonly="loading"></v-text-field>
              </v-col>
              <v-col cols="12">
                2. <span>{{ $t('ebill_assessment_account_number') }} <br>({{ $t('refer_assessment_bill') }}) <br><span class="error--text">*</span></span>
                <v-text-field outlined :placeholder="$t('enter_your_answer')" v-model="data.registered_assessment_account_number" name="ebill_assessment_account_number" type="text" required :rules="[rules.required]" :disabled="loading" :readonly="loading"></v-text-field>
              </v-col>
              <v-col cols="12">
                3. <span>{{ $t('ebill_relationship_with_assessment_account') }} <br><span class="error--text">*</span></span>
                <v-select outlined :items="relationshipOptions" v-model="data.relationship_with_assessment_account" :rules="[rules.required]" name="relationship_with_assessment_account" :disabled="loading" :readonly="loading" />
                <v-text-field outlined :placeholder="$t('enter_your_answer')" v-if="data.relationship_with_assessment_account === 'other'" name="other_relationship_type" :label="$t('other_relationship_type')" v-model="data.other_relationship_type" :rules="[rules.required]" />
              </v-col>
              <v-col cols="12">
                4. <span>{{ $t('ic_num') }}<br> ({{ $t("for_verification_purpose") }}) <br><span class="error--text">*</span></span>
                <v-text-field outlined name="ic_num" :value="icFormat(data.customer.nric)" @input="data.customer.nric = $event" :counter="14" maxLength="14" :placeholder="$t('enter_your_answer')" required type="text" :disabled="loading" :readonly="loading" :rules="[rules.required, rules.nricLength, rules.dateOfBirth]"></v-text-field>
              </v-col>
              <v-col cols="12">
                5. <span>{{ $t('email_address') }}<br> ({{ $t("for_receiving_ebill") }}) <br><span class="error--text">*</span></span>
                <v-row wrap align="center" justify="center" class="text-center">
                  <v-col cols="12" sm="12" md="7" lg="7">
                    <v-text-field outlined v-model="data.customer.email" :placeholder="$t('enter_your_answer')" name="email_address" required type="email" :disabled="verify.resultEmail || loading" :readonly="loading || verify.resultEmail" :rules="[rules.required, rules.email]"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="5" lg="5" class="pt-0">
                    <v-btn color="primary" rounded outlined :disabled="currentTimeEmail > 0 || !checkEmailFormat(data.customer.email)" @click="sendVerification('Email')" v-if="!verify.resultEmail">
                      {{ sentEmail ? $t(`resend_verification`, { channel: $t('email') }) : $t('send_verification', { channel: $t('email') }) }} <span v-if="currentTimeEmail > 0">({{ currentTimeEmail }} s)</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row wrap align="center" justify="center" v-if="sentEmail">
                  <v-col md="10" sm="12" cols="12">
                    <v-text-field prepend-icon="fa-code fa-lg" validate-on-blur :rules="[rules.required]" v-model="verify.inputEmail" :label="$t('verification_code')" name="code" required type="text" :disabled="verify.resultEmail"></v-text-field>
                  </v-col>
                  <v-col md="2" sm="12" cols="12" class="text-center">
                    <v-btn color="primary" rounded outlined :disabled="verify.inputEmail.length === 0 || verify.resultEmail" @click="verifyCode('Email')">
                      {{ $t("verify") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                6. <span>{{ $t('phone_no') }}<br> ({{ $t("for_receiving_sms") }}) <br><span class="error--text">*</span></span>
                <v-row wrap align="center" justify="center" class="text-center">
                  <v-col cols="12" sm="12" md="7" lg="7">
                    <v-text-field prefix="+6" class="pt-2" maxLength="11" outlined :placeholder="$t('enter_your_answer')" v-model="data.customer.phone" name="phone_no" type="tel" :disabled="verify.resultSMS || loading" :readonly="loading || verify.resultSMS" required :rules="[rules.required]"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="5" lg="5" class="pt-0">
                    <v-btn color="primary" rounded outlined :disabled="currentTimeSMS > 0 || data.customer.phone.length < 10" @click="sendVerification('SMS')" v-if="!verify.resultSMS">
                      {{ sentSMS ? $t(`resend_verification`, { channel: 'SMS' }) : $t('send_verification', { channel: 'SMS' }) }} <span v-if="currentTimeSMS > 0">({{ currentTimeSMS }} s)</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row wrap align="center" justify="center" v-if="sentSMS">
                  <v-col md="10" sm="12" cols="12">
                    <v-text-field prepend-icon="fa-code fa-lg" validate-on-blur :rules="[rules.required]" v-model="verify.inputSMS" :label="$t('verification_code')" name="code" required type="text" :disabled="verify.resultSMS"></v-text-field>
                  </v-col>
                  <v-col md="2" sm="12" cols="12" class="text-center">
                    <v-btn color="primary" rounded outlined :disabled="verify.inputSMS.length === 0 || verify.resultSMS" @click="verifyCode('SMS')">
                      {{ $t("verify") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                7. Customer Declaration <br/><br/>
                By clicking the submit button below, I hereby:<br><br>
                (a) confirm that the information provided herein is correct, updated and true.<br><br>
                (b) give consent to the use of my information for the purposes as stipulated in Privacy Notice For Council issued.<br><br>
                (c) understand that once I sign up to e-billing service, I agree not to receive printed assessment account bill from Council from my next bill onwards.<br><br>
                <span class="error--text">*</span><br>
                <v-radio-group
                  v-model="data.termsAgreed"
                >
                  <v-radio
                    :value="true"
                  >
                    <template v-slot:label>
                      <div class="black--text">
                        I agree to the above Terms & Conditions.
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card>
          <br />
          <v-layout justify-end mt-2>
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" large rounded type="submit" :disabled="loading || !data.termsAgreed" :loading="loading">{{ $t('submit') }}</v-btn>
          </v-layout>
        </v-form>
    </v-col>
    <canvas id="imageCanvas" class="d-none" />
  </v-row>
</template>

<script>
import axios from '../../axios'
import configuration from '../../configurations'
import throttle from 'lodash/throttle'
import { mapActions } from 'vuex'

export default {
  computed: {
    rules () {
      return {
        dateOfBirth: value => (value && value.length > 6 ? (((parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) < 32 && parseInt(value.replace(/[\s-]/g, '').substr(4, 2)) > 0) && (parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) < 13 && parseInt(value.replace(/[\s-]/g, '').substr(2, 2)) > 0)) || this.$t('invalidDateOfBirth')) : true),
        required: value => !!value || this.$t('requiredField'),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('invalidEmailFormat')
        },
        percentage: value => (Number(value) <= 100 && Number(value) >= 0) || this.$t('invalidPercentage'),
        nricLength: value => (value ? (value.replace(/[\s-]/g, '').length === 12 || this.$t('invalidNRICFormat')) : true)
      }
    },
    relationshipOptions () {
      return this.relationships.map(opt => ({ text: this.$t(opt), value: opt }))
    }
  },
  data: () => ({
    relationships: ['owner', 'tenant', 'spouse', 'parent', 'sibling', 'child', 'employer', 'employee', 'other'],
    data: {
      _id: '',
      registered_assessment_account_number: '',
      relationship_with_assessment_account: 'owner',
      other_relationship_type: '',
      customer: {
        name: '',
        nric: '',
        phone: '',
        email: ''
      },
      termsAgreed: false,
      status: 'new',
      channel: 'e-Services',
      type: 'subscription_form'
    },
    loading: false,
    currentTimeEmail: 0,
    currentTimeSMS: 0,
    verify: {
      codeEmail: null,
      codeSMS: null,
      inputEmail: '',
      inputSMS: '',
      resultEmail: false,
      resultSMS: false
    },
    sentEmail: false,
    sentSMS: false,
    timer: null
  }),
  beforeMount: async function () {
    window.scrollTo(0, 0)
    this.$store.commit('loading/setPageLoading', { loading: false })
    const user = await this.$store.dispatch('auth/session')
    if (user.userCtx.name && user.userCtx.name.length > 0 && !user.userCtx.roles.includes('_admin')) {
      this.verify.result = true
      this.data.customer = Object.assign({}, this.data, { name: user.userCtx.full_name || '', phone: user.userCtx.phone || '', email: user.userCtx.name || '', nric: user.userCtx.ic_num || '' })
    }

    navigator.geolocation.getCurrentPosition(function (position) {
      const geolocation = {
        coords: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          altitude: position.coords.altitude,
          accuracy: position.coords.accuracy,
          altitudeAccuracy: position.coords.altitudeAccuracy,
          heading: position.coords.heading,
          speed: position.coords.speed
        },
        timestamp: position.timestamp
      }
      this.data.geolocation = geolocation
    }.bind(this), (error) => { alert(error.message) }, { enableHighAccuracy: true })
  },
  methods: {
    ...mapActions(['sendSMS']),
    checkEmailFormat (value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value)
    },
    countdown (channel) {
      if (this[`currentTime${channel}`] > 0) {
        this[`currentTime${channel}`] -= 1
        setTimeout(() => this.countdown(channel), 1000)
      } else {
        this[`currentTime${channel}`] = 0
      }
    },
    sendVerification: throttle(async function (channel) {
      this[`currentTime${channel}`] = 180
      this.verify[`code${channel}`] = Math.floor(100000 + Math.random() * 900000).toString()
      setTimeout(() => this.countdown(channel), 1)
      this[`sent${channel}`] = true
      const payload = {
        channel: channel.toLowerCase(),
        contact: this.data.customer.email.replace(/\s/g, ''),
        message: `Hi,<br/><br/>Your MDKGU e-Billing Email Verification Code is<br/><br/><strong>${this.verify[`code${channel}`]}</strong><br/><br/>for e-Billing subscription. The code will expires in 3 mins.<br/><br/>*Note: If you didn't request any email verification code, please ignore this message.`,
        subject: `no-reply: MDKGU e-Billing Email Verification Code`
      }
      if (channel === 'SMS') {
        payload.contact = this.data.customer.phone.replace(/\s/g, '')
        payload.message = `Your ${channel} verification code is ${this.verify[`code${channel}`]} for e-billing subscription. Expires in 3 mins. Date: ${new Date().toLocaleString()}`
        delete payload.subject
      }
      await this.sendSMS(payload)
    }, 1000),
    verifyCode (channel) {
      if (this.verify[`code${channel}`] === this.verify[`input${channel}`]) {
        this.verify[`result${channel}`] = true
        this.$store.dispatch('snackbar/setSnackBar', {color: 'success', message: this.$t('verify_successful'), visible: true})
        return
      }
      this.verify[`result${channel}`] = false
      this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message: this.$t('invalid_code'), visible: true})
    },
    icFormat (value) {
      if (!value) return ''
      const format = value.replace(/[-\s]/g, '')
      if (format.length > 8) return `${format.substr(0, 6)}-${format.substr(6, 2)}-${format.substr(8)}`
      if (format.length > 6) return `${format.substr(0, 6)}-${format.substr(6, 2)}`
      return format
    },
    submitForm: throttle(async function ($event) {
      this.loading = true
      const result = this.$refs.form.validate()
      if (!result) {
        this.loading = false
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$t('incomplete_form'),
          visible: true
        })
        return
      }
      if (!this.verify.resultEmail) {
        this.loading = false
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$t('email_is_not_verify'),
          visible: true
        })
        return
      }
      if (!this.verify.resultSMS) {
        this.loading = false
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: this.$t('phone_is_not_verify'),
          visible: true
        })
        return
      }
      this.data.registered_assessment_account_number = this.data.registered_assessment_account_number.trim()
      this.data.other_relationship_type = this.data.other_relationship_type.trim()
      let isExist = false
      try {
        await axios({
          url: `${configuration.WORKER}/ebilling/${btoa(this.data.registered_assessment_account_number)}-${btoa(this.data.customer.email)}`,
          method: 'GET'
        })
        isExist = true
      } catch (error) {
        if (error.response.data.error !== 'not_found') throw error
      }
      if (isExist) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'success',
          message: this.$t('submit_successful'),
          visible: true
        })
        this.loading = false
        this.resetForm()
        return
      }
      try {
        const { data: result } = await axios({
          url: `${configuration.WORKER}/assessments`,
          method: 'POST',
          data: {
            data: {
              _id: this.data.registered_assessment_account_number,
              council: configuration.council,
              payment_type: 'assessment'
            }
          }
        })
        if (result.rows.filter(row => row.assessment_account_id === this.data.registered_assessment_account_number).length === 0) {
          this.loading = false
          this.$store.dispatch('snackbar/setSnackBar', {
            color: 'red',
            message: this.$t('invalid_assessment_account_number'),
            visible: true
          })
          return
        }
        this.data.customer.name = this.data.customer.name.trim().toUpperCase()
        this.data.customer.phone = this.data.customer.phone.replace(/\s/g, '')
        this.data.customer.email = this.data.customer.email.replace(/\s/g, '')
        this.data.channel = `e-Services`
        await axios({
          url: `${configuration.WORKER}/ebilling`,
          method: 'POST',
          data: this.data,
          headers: {
            'Content-Type': 'application/json'
          }
        })
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'success',
          message: this.$t('submit_successful'),
          visible: true
        })
        this.resetForm()
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: error.message || error,
          visible: true
        })
      } finally {
        this.loading = false
      }
    }, 500),
    resetForm () {
      this.data = {
        _id: '',
        registered_assessment_account_number: '',
        relationship_with_assessment_account: 'owner',
        other_relationship_type: '',
        customer: {
          name: '',
          nric: '',
          phone: '',
          email: ''
        },
        termsAgreed: false,
        status: 'new',
        channel: 'e-Services',
        type: 'subscription_form'
      }
      this.$refs.form.resetValidation()
      window.scrollTo(0, 0)
    }
  }
}
</script>
